// src/App.js
import React, { useState } from 'react';
import MainMenu from './components/MainMenu';
import GameScreen from './components/GameScreen';

function App() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Handle category selection
  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  // Handle going back to the main menu
  const handleBackToMenu = () => {
    setSelectedCategory(null);
  };

  return (
    <div className="App">
      {!selectedCategory ? (
        <MainMenu onCategorySelect={handleCategorySelect} />
      ) : (
        <GameScreen selectedCategory={selectedCategory} onBack={handleBackToMenu} />
      )}
    </div>
  );
}

export default App;